const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class CulturalHeritage extends Action {
    constructor(age){
        super(
            age,
            ActionNames.CulturalHeritage,
            `Score ${CulturalHeritage.GetScienceAmount(age)} science and ${CulturalHeritage.GetCultureAmount(age)} culture.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetScienceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 1;
            case Age.Age1:
                return 2;
        }
    }

    static GetCultureAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 4;
            case Age.Age1:
                return 2;
        }
    }
}

module.exports = CulturalHeritage;
